import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import { stripTrailingZeroDecimals, useFormatPrice } from '@src/blocks/currency'
import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface TraditionalPriceColumnProps {
  formattedTraditionalPrice: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  showNewPdpDesignV2?: boolean
  updatedDesignForV2?: boolean
}

// Renders the strikethrough traditional price + "Traditional retail" caption, laid out inline
// when an offer price is present.
function TraditionalPriceColumn({
  formattedTraditionalPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  showNewPdpDesignV2,
  updatedDesignForV2,
}: TraditionalPriceColumnProps) {
  const { t } = useTranslation('common')
  const formatPrice = useFormatPrice()
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const isOffer = !!(formattedFestivalOfferPrice || isSubscriptionOffer)
  const isFestivalRp = isOffer && !!showNewPdpDesignV2
  const isOfferInline = isOffer && !showNewPdpDesignV2
  return (
    <div className={isOfferInline ? styles.priceWrapperTraditionalRetailInlineCss : styles.priceWrapperMainCss}>
      <div
        className={cx(
          isOfferInline ? styles.priceWrapperMainValueRpOfferCss : styles.priceWrapperMainValueCss,
          styles.priceWrapperMainValueRpDecorationRecipe({ festival: isFestivalRp }),
          !isOfferInline && formattedFestivalOfferPrice && styles.priceWrapperMainMarginCss,
          showNewPdpDesignV2 && styles.priceWrapperMainValueRpNewDesignV2Css,
          isFestivalRp && styles.priceWrapperMainValueRpNewDesignV2FestivalWeightCss,
          updatedDesignForV2 && styles.priceWrapperMainValueRpUpdatedDesignV2Css,
        )}
      >
        <span className="traditionalPrice_selector_for_force_update">
          {isFestivalRp ? (
            t('vs_traditional_retail', {
              value: stripTrailingZeroDecimals(formatPrice(formattedTraditionalPrice)),
            })
          ) : (
            <FormattedPrice amount={formattedTraditionalPrice} />
          )}
        </span>
      </div>
      {!showNewPdpDesignV2 && (
        <div
          className={cx(
            styles.priceWrapperMainTextCss,
            styles.priceWrapperMainTextRpCss,
            !isOfferInline && styles.priceWrapperMainMarginCss,
            updatedDesignForV2 && styles.priceWrapperMainTextUpdatedDesignV2Css,
          )}
        >
          {t('traditional_retail')}
        </div>
      )}
    </div>
  )
}

export default TraditionalPriceColumn
